import { ReferralCodeI } from './interfaces/Referrals';
import { MOCK_REFERRAL_CODE } from './mockData';

// POST /referrals/codes
// Creates or retrieves the referral code for the authenticated user.
// Called when opening the "Invite a friend" modal from anywhere in the app.
const getMyReferralCode = async (token: string): Promise<ReferralCodeI> => {
	if (process.env.REACT_APP_MOCK_REFERRALS === 'true') {
		return Promise.resolve(MOCK_REFERRAL_CODE);
	}

	const response = await fetch(`${process.env.REACT_APP_BASE_API}/referrals/codes`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		}
	});

	if (!response.ok) {
		let detail = 'Unknown error';
		try {
			const body = await response.json();
			detail = (body as { message?: string }).message ?? detail;
		} catch {} // eslint-disable-line no-empty
		throw new Error(`HTTP ${response.status}: ${detail}`);
	}

	// Comparsa envuelve toda respuesta correcta en ArcaResponse { data, code, ... }
	const body = (await response.json()) as { data: ReferralCodeI };
	return body.data;
};

export default getMyReferralCode;
